import script from "./DataInconsistency.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataInconsistency.vue?vue&type=script&setup=true&lang=ts"

import "./DataInconsistency.vue?vue&type=style&index=0&id=420298e9&lang=scss"

const __exports__ = script;

export default __exports__